import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStackedBarChart100Axis: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconStackedBarChart100Axis"><Path d="M3 3H5V19H21V21H3V3ZM7 12H9V18H7V12ZM12 10H14V18H12V10ZM17 13H19V18H17V13ZM17 5H19V11H17V5ZM7 5H9V10H7V5ZM12 5H14V8H12V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStackedBarChart100Axis;
